import React, { createContext, useContext, useState, ReactNode } from 'react'

// type TaskDetailsType = {
//   id: string
//   title: string
//   description?: string
// }

type TaskDetailsType = any
interface TaskDetailsContextType {
  taskDetails: TaskDetailsType | undefined
  setTaskDetails: React.Dispatch<
    React.SetStateAction<TaskDetailsType | undefined>
  >
  clearTaskDetails: () => void
}

const TaskDetailsContext = createContext<TaskDetailsContextType | undefined>(
  undefined
)

export const TaskDetailsProvider = ({ children }: { children: ReactNode }) => {
  const [taskDetails, setTaskDetails] = useState<TaskDetailsType>()

  // clear function
  const clearTaskDetails = () => {
    setTaskDetails(undefined) // or setTaskDetails(null) if you prefer
  }

  return (
    <TaskDetailsContext.Provider
      value={{ taskDetails, setTaskDetails, clearTaskDetails }}
    >
      {children}
    </TaskDetailsContext.Provider>
  )
}

export const useTaskDetails = () => {
  const context = useContext(TaskDetailsContext)
  if (!context) {
    throw new Error('useTaskDetails must be used within a TaskDetailsProvider')
  }
  return context
}
